import { TrustBadge } from "@/components/shared";
import { ArrowRight } from "lucide-react";

export function SettingCard({ icon: Icon, title, desc, children }) {
  return (
    <div className="rounded-xl border border-border bg-card p-5 space-y-4">
      <div><div className="flex items-center gap-2 font-semibold"><Icon className="h-4 w-4 text-primary" /> {title}</div><p className="text-xs text-muted-foreground mt-0.5">{desc}</p></div>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

export function Row({ label, children }) {
  return <div className="flex items-center justify-between gap-4"><span className="text-sm">{label}</span>{children}</div>;
}

export function InsightCard({ icon: Icon, title, metric, desc, tone = "ok", onOpen, cta, testId, progress }) {
  const warn = tone === "warn";
  return (
    <div className={`rounded-xl border ${warn ? "border-amber-500/40" : "border-border"} bg-card p-5 flex flex-col gap-3`} data-testid={testId}>
      <div className="flex items-center justify-between">
        <div className="h-9 w-9 rounded-lg bg-primary/15 flex items-center justify-center"><Icon className="h-4 w-4 text-primary" /></div>
        {warn ? <TrustBadge type="flag">attention</TrustBadge> : <TrustBadge type="high">ok</TrustBadge>}
      </div>
      <div>
        <div className="text-sm text-muted-foreground">{title}</div>
        <div className={`text-2xl font-display font-bold ${warn ? "text-amber-400" : "text-foreground"}`}>{metric}</div>
      </div>
      {progress != null && <div className="h-1.5 rounded-full bg-muted overflow-hidden"><div className="h-full rounded-full bg-amber-500" style={{ width: `${Math.min(progress, 100)}%` }} /></div>}
      <p className="text-xs text-muted-foreground flex-1">{desc}</p>
      <button onClick={onOpen} data-testid={`${testId}-open`} className="text-xs text-primary hover:underline flex items-center gap-1 self-start">{cta} <ArrowRight className="h-3 w-3" /></button>
    </div>
  );
}
